import React from 'react';
import './index.scss';
import { detector } from '../../lib/util/Detect.js';
import { appVersionComapare } from '../../lib/kbApp/kbJsBridgePromise';

class TitleBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.ua = window.navigator.userAgent;
  }

  componentDidMount() {
    if (!detector.app.kuaibao) {
      this.setState({
        show: true,
      });
    }
  }

	gohome = () => {
	  if (
	    /FF/.test(this.ua)
			&& window.history
			&& window.history.pushState
	  ) {
	    window.history.back();
	    return;
	  }
	  this.backToHome();
	}

	backToHome = () => {
	  if (
		  window.browser
		  && window.browser.app
		  && window.browser.app.historyBack
	  ) {
	      window.browser.app.historyBack();
	  } else if (detector.os.android) { // Android直接后退
		  	this.$router.go(-1);
	  } else if (appVersionComapare('9.2')) {
		  	window.location.href = 'qb://tab/usercenter';
	  } else {
		  	window.location.href = 'qb://home';
	  }
	}

	render() {
	  const { title = '福利中心' } = this.props;

	  return (
			<div className={`titleBar ${this.props.from == 'index' ? 'fromIndex' : ''}`}>
				{this.state.show
					&& <div className="title">
						<div className="left" onClick={() => this.gohome()}></div>
						{title}
					</div>
				}
			</div>
	  );
	}
}

export default TitleBar;
